import * as icons from './icons';
export * from './icons';
export * from './types';
export { default as AbstractIcon } from './AbstractIcon';
export { default as iconSizes } from './iconSizes';
export default icons;